var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4974_610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0C0.596953 0 0 0.596954 0 1.33333V14.6667C0 15.403 0.596954 16 1.33333 16H11.9619L16 11.9615V1.33333C16 0.596954 15.403 0 14.6667 0H1.33333ZM3.80952 4.19048H12.5714V4.95238H3.80952V4.19048ZM3.80952 6.47619H12.5714V7.2381H3.80952V6.47619ZM3.80952 8.7619H12.5714V9.52381H3.80952V8.7619ZM11.8095 15.0857V11.8095H15.0857L11.8095 15.0857Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4974_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.29f55aebc4aeb1872ca1ccf57039dbaf.svg";
export { ForwardRef as ReactComponent };